import chroma from "chroma-js";
import palette from "../colors/dark-theme";

const { text } = palette;

export const MuiAccordion: any = {
  styleOverrides: {
    root: {
      "&.MuiPaper-root": {
        margin: "0px !important",
      },
      "&.Mui-expanded": {
        minHeight: "0 !important",
      },
    },
  },
};

export const MuiAccordionSummary: any = {
  styleOverrides: {
    root: {
      backgroundColor: chroma(palette.background.default).darken(0.5).css(),
      minHeight: "30px !important",
      marginBottom: "0px !important",
      marginTop: "0px !important",
      borderBottom: `1px solid  ${chroma(palette.background.default).brighten(0.5).css()}`,
      "&.Mui-expanded, & .Mui-expanded": {
        minHeight: "30px !important",
        marginBottom: "0px !important",
        marginTop: "0px !important",
      },
      "& .MuiAccordionSummary-content": {
        minHeight: "30px !important",
        marginBottom: "3px !important",
        marginTop: "3px !important",
        dislay: "flex",
        alignItems: "center",
      },
    },
  },
};

export const MuiAccordionDetails: any = {
  styleOverrides: {
    root: { backgroundColor: palette.background.paper },
  },
};
